import Actions from '../actions/actions';
import { invitesCRUDActions } from '../actions/InvitesCRUDActions';
import {
  setBusy,
  retrieved,
  retrievedAll,
  setUnBusy,
  deleteLocalFirst,
} from './common/commonReducers';
import { InviteState } from '../interfaces/invite';
import usersCRUDActions from '../actions/UsersCRUDActions';

const initialState: InviteState = {
  busy: false,
  pagesWithAvailableSeats: [],
  entities: [],
};

export default function invite(state = initialState, action) {
  switch (action.type) {
    // TODO discuss team's approach to redux action naming as well as state modeling
    // Shared state issue can be solved with selectors and relative entities
    case usersCRUDActions.updateUserAttributesSessionAction:
      return initialState;
    case invitesCRUDActions.setAvailableSeatsAction:
      return { ...state, pagesWithAvailableSeats: action.seats.ids };
    case invitesCRUDActions.busyAction:
      return setBusy(state);
    case invitesCRUDActions.unbusyAction:
      return setUnBusy(state);
    case invitesCRUDActions.retrievedAction:
      return retrieved(state, action);
    case invitesCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case invitesCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
